const en = {
  app: { name: "OELOX POS", version: "v1.0" },
  nav: { pos: "POS", orders: "Orders", drivers: "Drivers", crm: "CRM", kds: "KDS", livecall: "Live Call", settings: "Settings", signOut: "Sign Out", soon: "soon" },
  header: { notifications: "Notifications", settings: "Settings", toggleTheme: "Toggle theme", toggleLang: "Change language", toggleSidebar: "Menu" },
  auth: { title: "OELOX POS", subtitle: "Sign in to your restaurant account", email: "Email", password: "Password", signIn: "Sign In", signingIn: "Signing in…", error: "Invalid email or password" },
  pos: {
    all: "All", noItems: "No items in this category", loading: "Loading menu…", cart: "Cart",
    emptyCart: "Tap items to add", subtotal: "Subtotal", total: "Total", each: "each",
    placeOrder: "Place Order", placing: "Placing…", pay: "Pay", print: "Print", tapToAdd: "Tap items to add",
    payModal: { title: "Total", subtitle: "Select payment method", cash: "Cash", card: "Card" },
    notAuth: "Not authenticated", notAuthHint: "Log in via the OELOX Dashboard first, then refresh.",
    customer: "Customer", customerName: "Customer name", customerPhone: "Phone", customerAddress: "Address",
    noCustomerFound: "No customer found", addCustomer: "Add New Customer", newCustomer: "New Customer",
    optional: "optional", cancel: "Cancel", save: "Save", continueWithName: "Continue with",
    walkInCustomer: "Walk-in Customer",
    customerAdded: "Customer added", duplicatePhone: "Phone number already exists",
    addCustomerFailed: "Failed to add customer",
    orderCreated: "Order created", orderFailed: "Failed to create order. Please try again.",
    orderQueued: "Order queued — will sync when online",
  },
  orders: {
    title: "Orders", loading: "Loading orders…", noOrders: "No orders", noOrdersHint: "New orders will appear here",
    pending: "Pending", kitchen: "Kitchen", ready: "Ready", driver: "Driver", done: "Done",
    accept: "Accept", decline: "Decline", startCooking: "Start Cooking", markReady: "Mark Ready", complete: "Complete",
    acceptOrder: "Accept Order",
    detail: {
      customer: "Customer", items: "Items", subtotal: "Subtotal", deliveryFee: "Delivery Fee", total: "Total",
      source: "Source", status: "Status", fulfillment: "Fulfillment", created: "Created",
    },
  },
  drivers: {
    title: "Drivers", loading: "Loading drivers…", noDrivers: "No drivers",
    total: "total", online: "online", delivering: "delivering",
    keys: "Keys", noPasscodes: "No passcodes. Create them from the OELOX Dashboard.",
    blocked: "Blocked", onlineStatus: "Online", offline: "Offline", trips: "trips",
    vehicle: "Vehicle", type: "Type", number: "Number", model: "Model", year: "Year", color: "Color",
    kpi: { trips: "Trips", rating: "Rating", acceptance: "Acceptance", wallet: "Wallet", codPending: "COD Pending", feesEarned: "Fees Earned" },
    recentTrips: "Recent Trips", assignedOrders: "Assigned Orders",
    block: "Block", unblock: "Unblock",
    meta: { joined: "Joined", verified: "Verified", yes: "Yes", no: "No", cod: "COD" },
  },
  kds: {
    title: "Kitchen Display", orders: "orders",
    new: "New Orders", preparing: "Preparing", readyCol: "Ready",
    noOrders: "No orders", startCooking: "Start Cooking", starting: "Starting…",
    markReady: "Mark Ready", marking: "Marking…", readyForPickup: "✅ Ready for pickup",
    moreItems: "more items", justNow: "just now",
  },
  settings: {
    title: "Settings", language: "Language", languageDesc: "Choose your preferred language for the POS interface.",
    theme: "Theme", themeDesc: "Switch between light and dark appearance.",
    light: "Light", dark: "Dark",
    account: "Account", accountDesc: "Signed in as",
    signOut: "Sign Out", signOutDesc: "Leave the POS terminal.",
    about: "About", aboutDesc: "OELOX POS Terminal",
  },
  loading: "Loading…",
};

export default en;
